import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ReviewForm.css';
import DocumentLink from 'components/shared/document/DocumentLink';
import LogoUpload from 'components/shared/logo-upload/LogoUpload';
import moment from 'moment';

class ProjectOpenItemReview extends Component {
  static propTypes = {
    openItem: PropTypes.shape({}).isRequired,
  };

  render() {
    const { openItem } = this.props;
    return (
      <div className="review-form-trade-block review-form-project-open-item">
        <div className="review-form-title-bloc">
          <p className="review-form-block-title review-form-block-title-open-item">
            <span>OPEN ITEM{!!openItem.critical && ' - CRITICAL'}</span>
          </p>
          <p className="review-form-block-title review-form-block-title-open-item review-form-block-assignee-due-date">
            {!!openItem.assignee_label && (
              <span>Assigned To: {openItem.assignee_label}</span>
            )}
            {!!openItem.resolve_by && (
              <span>
                Due Date: {moment(openItem.resolve_by).format('MM/DD/YYYY')}
              </span>
            )}
          </p>
          {openItem.recipients && openItem.recipients.length > 0 && (
            <p className="review-form-block-title">
              CC Recipient(s):{' '}
              {openItem.recipients
                .map((rcpt) => `${rcpt.first_name} ${rcpt.last_name}`)
                .join(', ')}
            </p>
          )}
        </div>
        <div className="review-form-trade-block">
          <div className="review-form-text-block">{openItem.description}</div>
        </div>
        {openItem.documents && openItem.documents.length > 0 && (
          <div className="review-form-trade-block">
            {openItem.documents.map((doc, index) => {
              return (
                <div className="doc-viewer" key={index}>
                  <DocumentLink url={doc.document.url} />
                </div>
              );
            })}
          </div>
        )}
        {openItem.images && openItem.images.length > 0 && (
          <div className="review-form-trade-block">
            <div className="review-block-images-wrapper">
              <LogoUpload
                readOnly
                logos={openItem.images.map((image) => ({
                  preview: image.image.gallery.url,
                  url: image.image.url,
                }))}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ProjectOpenItemReview;



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-daily-report-log/ProjectOpenItemReview.js